/* eslint-disable react/no-unescaped-entities */
import aspectRatio from "components/utils/aspectRatio";
import getYear from "date-fns/getYear";
import getBaseUrl from "lib/utils/getBaseUrl";
import { FormattedMessage } from "react-intl";

export default function Disclaimers() {
  const copyright = <>© {getYear(new Date())}</>;
  const intrinio = (
    <a
      href="https://intrinio.com/"
      target="_blank"
      rel="noopener noreferrer"
      className="font-medium text-slate-600 hover:underline hover:underline-offset-4 dark:text-slate-400"
    >
      Intrinio Inc.
    </a>
  );
  const enfoque = (
    <a
      href="https://www.enfoque.com.br/"
      target="_blank"
      rel="noopener noreferrer"
      className="font-medium text-slate-600 hover:underline hover:underline-offset-4 dark:text-slate-400"
    >
      Enfoque Informações Financeiras LTDA
    </a>
  );
  const fiscal = (
    <a
      href="https://fiscal.ai/"
      target="_blank"
      rel="noopener noreferrer"
      className="font-medium text-slate-600 hover:underline hover:underline-offset-4 dark:text-slate-400"
    >
      Fiscal.ai
    </a>
  );

  return (
    <section className="mx-auto grid max-w-7xl justify-center gap-y-12 px-4 text-center xl:w-full xl:px-0">
      <p className="m-0 text-sm font-normal tracking-wide text-zinc-500 dark:text-zinc-400 lg:text-justify lg:leading-relaxed">
        <FormattedMessage
          defaultMessage={`
<strong>Disclaimers:</strong> {copyright} Os dados fundamentalistas de empresas Americanas ("Stocks / REITs") são fornecidos
pela {fiscal}, atualizados diariamente. Cotações de ativos Brasileiros ("Ações / FIIs") são fornecidos pela {copyright} {enfoque}, cotações de ativos
Americanos ("Stocks / REITs") são fornecidos pela {copyright} {intrinio} e atualizados diariamente. Dados de moedas (Forex) são fornecidos
pela {copyright} apilayer Data Products GmbH ("Currencylayer"), atualizados diariamente. Outros dados embutidos nas páginas das empresas tem
origem direta dos sistemas dos órgãos regulatórios como CVM ("Comissão de Valores Mobiliários") /
SEC ("U.S. Securities and Exchange Commission"), como também podem ser obtidos de comunicados oficiais das empresas em questão. O
Fundamentei não se responsabiliza pela precisão/completude ou integridade das informações apresentadas no site ou em qualquer um de
seus produtos. O Fundamentei também não se responsabiliza por quaisquer danos ou prejuízos decorrentes do uso dessas informações.
          `}
          id="BgJoi0"
          values={{
            // eslint-disable-next-line react/no-unstable-nested-components
            strong: (children) => <strong>{children}</strong>,
            copyright,

            intrinio,
            enfoque,
            fiscal,
          }}
        />
      </p>
      <img
        className="mx-auto lg:mx-0 lg:ml-auto"
        alt="Apimec"
        src={`${getBaseUrl()}/static/compliance/apimec.png`}
        {...aspectRatio({
          originalWidth: 498,
          originalHeight: 498,
          desiredWidth: 64,
        })}
      />
    </section>
  );
}
